@if (!isProtected || enabled) {
  <ng-container *ngTemplateOutlet="ngContentTpl" />
}
@if (isProtected && !enabled) {
  @if (!useOriginalTemplate()) {
    <rt-dropdown-item (click)="facade.showFeatureInfo(mode, feature); $event.stopPropagation()">
      <rt-icon prefix [size]="'medium'" [name]="iconName()" />
      <rt-heading variant="heading">
        {{ heading() }}
      </rt-heading>
      <div class="info-dropdown-text">
        {{ subheading() }}
      </div>
      <rt-icon suffix name="upgrade" size="small-x" [colorToken]="$any(colorToken())" />
    </rt-dropdown-item>
  } @else {
    <div
      (click)="facade.showFeatureInfo(mode, feature); $event.stopPropagation()"
      class="original-tpl-wrap"
    >
      <div class="original-tpl-content">
        <ng-container *ngTemplateOutlet="ngContentTpl" />
        <rt-icon
          name="upgrade"
          size="small-x"
          [colorToken]="$any(colorToken())"
          class="settings-icon-link"
        />
      </div>
    </div>
  }
}

<ng-template #ngContentTpl>
  <ng-content />
</ng-template>
